import SiteLayout from "@/components/feature/SiteLayout";
import SectionDivider from "@/components/base/SectionDivider";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import DentistHero from "@/pages/dentists/components/DentistHero";
import DentistOverview from "@/pages/dentists/components/DentistOverview";
import DentistFaq from "@/pages/dentists/components/DentistFaq";
import CtaSection from "@/pages/home/components/CtaSection";

export default function Dentists() {
  useDocumentMeta({
    title: "Diş Hekimleri İçin Görüntüleme Partneri | d.mar",
    description:
      "Diş hekimleri için dijital dental görüntüleme partneri. Aynı gün DICOM/JPG/PNG/PDF rapor teslimi, online erişim ve düşük doz modern cihazlar. Kliniğinizden hastalarınızı yönlendirin.",
    path: "/dis-hekimleri",
  });

  return (
    <SiteLayout>
      <DentistHero />
      <DentistOverview />
      <SectionDivider />
      <DentistFaq />
      <CtaSection />
    </SiteLayout>
  );
}